// @ts-nocheck

import React from 'react';

const Section = (props) => {
  const { children, title, testid } = props;
  return (
    <div className="section" data-testid={testid || title}>
      <div className="title">{title}</div>
      <div className="body">
        <div className="inner">{children}</div>
      </div>
    </div>
  );
};

export default Section;
